import { BrowserRouter as Router } from "react-router-dom";
import { Container } from "react-bootstrap";
import "./assets/styles/app.min.css";

import { Footer } from "./components/Layout";
import AppRouter from "./components/AppRouter";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Container fluid className="g-0" data-bs-theme="dark">
        <main>
          <AppRouter />
        </main>
      </Container>
      <Footer />
    </Router>
  );
}

export default App;
